import React from 'react';

import { Button } from '@mui/material';

import type { CloseButtonProperties } from './CloseButton.types';

export const CloseButton: React.FC<CloseButtonProperties> = ({
  onClick,
  color,
  className,
  isDisabled,
  label = 'Закрыть',
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <Button
      data-testid='close_button'
      onClick={handleClick}
      className={className}
      color={color}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );
};
